import { detect } from 'detect-browser';
let detectedInfo;
const getDetectedInfo = () => {
    if (detectedInfo === undefined) {
        detectedInfo = detect();
    }
    return detectedInfo;
};
/**
 * Helper to retrieve current browser details
 */
export const getBrowserDetails = () => {
    const info = getDetectedInfo();
    if (!info) {
        return undefined;
    }
    return {
        name: info.name,
        version: info.version,
    };
};
/**
 * Determines if the browser is on an iOS device.
 */
export const isIOS = () => {
    const info = getDetectedInfo();
    return Boolean(info && info.os === 'iOS');
};
